export function isDefined(value) {
    return value != null;
}
